import { atom } from 'recoil';

export const session = atom({
  key: 'session',
  default: {
    user: {},
    session: false,
    loaded: false,
    error: false,
    loggedOut: false,
    salesException: false
  }
});

export default session;
